import { PageHeader } from '@/components/layout/PageHeader';
import { DoctorDownloadScreen } from '@/components/features/download/DoctorDownloadScreen';
import { DownloadQueryProvider } from '@/contexts/DownloadQueryContext';

export function DoctorDownload() {
  return (
    <DownloadQueryProvider restrictUnavailableActivities>
      <div>
        <PageHeader
          title="Download Activities"
          description="Select patients and filter activities to download in bulk"
        />

        <DoctorDownloadScreen mode="processed" />
      </div>
    </DownloadQueryProvider>
  );
}
